<template>
  <v-app>
    <!-- ********** Headers ********** -->
    <template v-if="$route.name != 'Mosaic'">
    <Header :menu="0" :breadcrumbs="breadcrumbs" v-if="menu == 0" />
    <HeaderCS :breadcrumbs="breadcrumbs" v-if="menu == 1" />
    <HeaderCustom :breadcrumbs="breadcrumbs" v-if="menu == 2" />
    </template>

    <!-- ********** /Headers********** -->

    <!-- **********General content********** -->
    <v-content>
            
      <router-view @update="actualizar" @updateStatus="updateBreadcrumbs" @openSnackbar="openSnackbar"></router-view>

    </v-content>
    <!-- **********/General content********** -->

    <!-- **********Footer********** -->
    <Footer v-if="menu == 0"/>
    <FooterCS v-if="menu == 1" />
    <FooterCustom v-if="menu == 2" />

    <v-snackbar
      v-model="snackbar"
      top
    >
      <span class="white--text">Thank you!</span>
    </v-snackbar>

    <!-- **********/Footer********** -->
  </v-app>
</template>

<script>


export default {
  name: 'App',

  components: {
    Header: () => import('./components/Header'),
    HeaderCS: () => import('./components/HeaderCS'),
    HeaderCustom: () => import('./components/HeaderCustom'),
    Footer: () => import('./components/Footer'),
    FooterCS: () => import('./components/FooterCS'),
    FooterCustom: () => import('./components/FooterCustom')
  },

  data: () => ({
    //menu
    menu: 0,
    breadcrumbs: [
      {
        link: '/',
        text: 'Home',
        isLink: true
      },
      {
        link: '/furniture',
        text: 'Furniture',
        isLink: true
      }
    ],
    snackbar: false
  }),
  methods:{
    actualizar(x){
      this.menu = x;
    },
    updateBreadcrumbs: function(breadcrumbs){
      this.breadcrumbs = breadcrumbs;
    },
    openSnackbar: function(){
      this.snackbar = true;
    }
  },
};
</script>
